export default __webpack_public_path__ + "static/media/ajolote.a8819082.png";